(ns superadmin.announcements.view
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Chip$default" :as Chip]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Switch$default" :as Switch]
            ["@mui/material/Typography$default" :as Typography]
            ["@mui/x-data-grid-premium" :refer [DataGridPremium]]
            ["src/svg/inform/plus.svg$default" :as Plus]
            [common.queries :refer [use-mutation use-query]]
            [common.util]
            [common.widgets.data-grid :refer [grid-toolbar]]
            [common.widgets.page :as page]
            [re-frame.core :as rf]
            [superadmin.announcements.create-ocp.view]
            [superadmin.announcements.queries :as q]
            [uix.core :as uix :refer [$ defui]]))

(defui active-toggle-cell [{:keys [row]}]
  (let [{:keys [mutate isPending]} (use-mutation (q/update-announcement-mutation (:id row)))
        is-active (:isActive row)]
    ($ Switch
       {:checked (boolean is-active)
        :disabled isPending
        :size "small"
        :onChange (fn [_e]
                    (mutate {:id (:id row)
                             :isActive (not is-active)}))})))

(def ActiveToggleCell
  (uix/as-react
   (fn [params]
     ($ active-toggle-cell {:row (:row params)}))))

;; Routes display component
(defui routes-cell [{:keys [value]}]
  (if (or (nil? value) (empty? value))
    ($ Chip {:label "All routes" :size "small" :color "default"})
    ($ Stack {:direction "row" :spacing 0.5 :sx #js {:flexWrap "wrap"}}
       (for [route value]
         ($ Chip {:key route
                  :label route
                  :size "small"})))))

(def RoutesCell
  (uix/as-react
   (fn [params]
     ($ routes-cell {:value (:value params)}))))

(def columns
  #js [#js {:field "id"
            :headerName "ID"
            :width 80
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:id row))
            :sortable true}
       #js {:field "isActive"
            :headerName "Active"
            :width 80
            :sortable true
            :renderCell ActiveToggleCell
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:isActive row))}
       #js {:field "title"
            :headerName "Title"
            :flex 1
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:title row))
            :sortable true}
       #js {:field "routes"
            :headerName "Target Routes"
            :flex 1
            :sortable false
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:routes row))
            :renderCell RoutesCell}
       #js {:field "content"
            :headerName "Content"
            :flex 2
            :sortable false
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:content row))
            :renderCell (fn [^js params]
                          (let [value (.-value params)]
                            ($ Typography
                               {:variant "body2"
                                :sx #js {:overflow "hidden"
                                         :textOverflow "ellipsis"
                                         :whiteSpace "nowrap"}}
                               (if (> (count value) 100)
                                 (str (subs value 0 100) "...")
                                 value))))}
       #js {:field "createdAt"
            :headerName "Created At"
            :width 180
            :sortable true
            :type "dateTime"
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:createdAt row))
            :valueFormatter (fn [value]
                              (common.util/format-timestamp value))}])

(defn get-row-id [data] (:id data))

(def Toolbar
  (uix/as-react
   (fn []
     ($ grid-toolbar {:hide-quick-filter true
                      :direction "row-reverse"}
        ($ Button {:variant "contained"
                   :startIcon ($ Plus)
                   :onClick #(rf/dispatch [:ocp/open {:id :announcement/create}])}
           "New announcement")))))

(defui announcements-table []
  (let [{:keys [data isFetching]} (use-query (q/announcements-query))]
    ($ DataGridPremium
       {:columns columns
        :loading isFetching
        :rows (to-array data)
        :getRowId get-row-id
        :disableRowSelectionOnClick true
        :pageSizeOptions #js [10 25 50]
        :slots #js {:toolbar Toolbar}
        :initialState #js {:sorting #js {:sortModel #js [#js {:field "createdAt" :sort "desc"}]}
                           :pagination #js {:paginationModel #js {:pageSize 25}}}})))

(defui page-header []
  ($ page/page-header
     {:title "Announcements"}))

(defn announcements-page []
  ($ page/page
     ($ page-header)
     ($ page/content-padding
        ($ announcements-table))))
